import { Icon } from "@material-ui/core";
import React from "react";

import buttonStyles from "Styles/ButtonStyles.scss";
import styles from "./FilterCard.scss";

interface IProps {
    title: string;
    children?: React.ReactNode[] | React.ReactNode;
    className?: string;
    onClear?: () => void;
}

const FilterCard: React.FunctionComponent<IProps> = (props: IProps) => (
    <div className={`${styles.filterCard} ${styles.className}`}>
        <div className={styles.filterHeader}>
            <div className={styles.title}>{props.title}</div>
            { props.onClear &&
                <button className={`${styles.btnClear} ${buttonStyles.white} ${buttonStyles.small}`} onClick={props.onClear}>
                    <Icon>clear</Icon>
                    Clear
                </button>
            }
        </div>
        <div className={styles.content}>
            {props.children}
        </div>
    </div>
);

export default FilterCard;


// WEBPACK FOOTER //
// ./src/Components/Common/FilterBar/FilterCard/FilterCard.tsx